// extracted by mini-css-extract-plugin
export default {"modal":"SK-z","error":"TK-z","disabled":"UK-z","fields":"VK-z","errorMsg":"WK-z","footer":"XK-z","formContentWrapper":"YK-z","productImage":"ZK-z","overlay":"_K-z"};